export default __webpack_public_path__ + "static/media/YelekArcelik.c74fc5a2.jpg";